import React from 'react';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null };
    }

    static getDerivedStateFromError(error) {
        // Update state so the next render will show the fallback UI
        return { hasError: true, error };
    }

    componentDidCatch(error, errorInfo) {
        // Log the error to console
        console.error('ErrorBoundary caught an error:', error, errorInfo);
        
        // Check if it's an autofill-related error
        if (error.message && error.message.includes('Script error')) {
            console.warn('Autofill-related error caught by ErrorBoundary');
            // Don't show error UI for autofill errors, just log them
            this.setState({ hasError: false });
        }
    }

    render() {
        if (this.state.hasError) {
            // Fallback UI
            return (
                <div style={{ 
                    padding: '20px', 
                    textAlign: 'center', 
                    backgroundColor: '#f8f9fa',
                    border: '1px solid #dee2e6',
                    borderRadius: '8px',
                    margin: '20px'
                }}>
                    <h2>Щось пішло не так</h2>
                    <p>Будь ласка, перезавантажте сторінку або спробуйте пізніше.</p>
                    <button 
                        onClick={() => window.location.reload()} 
                        style={{
                            padding: '10px 20px',
                            backgroundColor: '#007bff',
                            color: 'white',
                            border: 'none',
                            borderRadius: '4px',
                            cursor: 'pointer'
                        }}
                    >
                        Перезавантажити
                    </button>
                </div>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
